import config from "@/config"
import http from "@/utils/request"
import tool from "@/utils/tool"
let storeId
if (tool.data?.get("USER_INFO")) {
  storeId = tool.data.get("USER_INFO").storeIds[0]
}
export default {
  permission: {
    list: {
      url: `${config.API_URL}`,
      // url: `${config.API_URL}/permission/store`,
      name: "店铺权限",
      get: async function (params) {
        return await http.get(`${this.url}/store/permission/listStorePermission`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/permission/store/createStorePermission`, data)
      },
      del: async function (data) {
        return await http.post(`${this.url}/store/permission/removeStorePermission`, data)
      },
      updataStatus: async function (data) {
        return await http.post(`${this.url}/updataStatus`, data)
      }
    }
  },
  role: {
    url: `${config.API_URL}/role/store`,
    name: "店铺角色",
    get: async function (params) {
      return await http.get(`${this.url}/getAllStoreRoles`, params)
    },
    submit: async function (data) {
      return await http.post(`${this.url}/createStoreRole`, data)
    },
    del: async function (data) {
      return await http.post(`${this.url}/delete`, data)
    },
    getpermissionIds: async function (params) {
      return await http.get(`${this.url}/getStoreRolePermissionIds`, params)
    },
    updateRolePermission: async function (data) {
      return await http.post(`${this.url}/updateStoreRolePermissions`, data)
    }
  },
  staff: {
    url: `${config.API_URL}`,
    name: "店铺角色",
    get: async function (params) {
      // const storeId = tool.data.get("STORE_ID")
      return await http.get(`${this.url}/store/staff/storeStafflist`, { storeId, ...params })
    },
    submit: async function (data) {
      // const storeId = tool.data.get("STORE_ID")
      return await http.post(`${this.url}/invitation/staff/createInvation`, { storeId, ...data })
    },
    del: async function (data) {
      return await http.post(`${this.url}/store/staff/removeStoreStaff`, data)
    },
    updateStoreRole: async function (data) {
      return await http.post(`${this.url}/store/staff/updateStoreRole`, data)
    },
    viewRoleOerate: async function (params) {
      return await http.get(`${this.url}/store/staff/storeStaffOperateList`, { ...params })
    },
    updataStatus: async function (data) {
      return await http.post(`${this.url}/updataStatus`, data)
    }
  },
  invitation: {
    url: `${config.API_URL}`,
    name: "入店邀请单",
    get: async function (params) {
      const storeId = tool.data.get("STORE_ID")

      return await http.get(`${this.url}/invitation/staff/inviteStoreStaffList`, { storeId, ...params })
    },
    submit: async function () {
      return
      // return await http.post(`${this.url}/invitation/staff/createInvation`, { storeId, ...data })
    },
    cancleInvitation: async function (data) {
      return await http.post(`${this.url}/invitation/staff/cancleInvitation`, data)
    }
  },
  product: {
    url: `${config.API_URL}`,
    name: "商品",
    get: async function (params) {
      const storeId = tool.data.get("STORE_ID")
      return await http.get(`${this.url}/store/product/getUpProduct`, { storeId, ...params })
    },
    submit: async function (data) {
      const storeId = tool.data.get("STORE_ID")
      return await http.post(`${this.url}/store/product/createStoreProduct`, { storeId, ...data })
    },
    update: async function (data) {
      const storeId = tool.data.get("STORE_ID")
      return await http.post(`${this.url}/store/product/updateStoreProduct`, { storeId, ...data })
    },
    cancleInvitation: async function (data) {
      return await http.post(`${this.url}/invitation/staff/cancleInvitation`, data)
    },
    setProductSku: async function (data) {
      return await http.post(`${this.url}/product/store/setProductSku`, data)
    },
    getProductSku: async function (data) {
      return await http.post(`${this.url}/product/store/getProductSku`, data)
    },
    pendingProduct: {
      get: async function (params) {
        const storeId = tool.data.get("STORE_ID")
        return await http.get(`${config.API_URL}/store/product/getPendingProduct`, { storeId, ...params })
      },
      getProductRemark: async function (data) {
        return await http.post(`${config.API_URL}/product/store/findByTarget`, { ...data }) //获取产品审核记录
      },
      upProductApply: async function (data) {
        const storeId = tool.data.get("STORE_ID")
        return await http.post(`${config.API_URL}/store/product/upProductApply`, { storeId, ...data }) //申请上架产品接口
      },
      submit: async function (data) {
        const storeId = tool.data.get("STORE_ID")
        return await http.post(`${config.API_URL}/store/product/createStoreProduct`, { storeId, ...data })
      },
      update: async function (data) {
        const storeId = tool.data.get("STORE_ID")
        return await http.post(`${config.API_URL}/store/product/updateStoreProduct`, { storeId, ...data })
      },
      //更新产品数据
    }
  },
  category: {
    url: `${config.API_URL}`,
    name: "商品分类",
    get: async function (params) {
      const storeId = tool.data.get("STORE_ID")
      return await http.get(`${this.url}/store/category/list`, { storeId, ...params })
    },
    submit: async function (data) {
      const storeId = tool.data.get("STORE_ID")
      return await http.post(`${this.url}/store/category/create`, { storeId, ...data })
    }
  },
  order: {
    url: `${config.API_URL}`,
    name: "获取店铺订单",
    get: async function (params) {
      const storeId = tool.data.get("STORE_ID")
      return await http.get(`${this.url}/store/order/getStoreOrderByStoreId`, { storeId, ...params })
    },
    getVerificationsByOrderId: async function (params) {
      const storeId = tool.data.get("STORE_ID")
      return await http.get(`${this.url}/store/order/getVerificationsByOrderId`, { storeId, ...params })
    }
    // submit: async function (data) {
    //   return await http.post(`${this.url}/store/produt/createStoreProduct`, { ...data })
    // },
    // cancleInvitation: async function (data) {
    //   return await http.post(`${this.url}/invitation/staff/cancleInvitation`, data)
    // }
  },
  verify: {
    url: `${config.API_URL}/store`,
    name: "获取店铺核销数据",
    get: async function (params) {
      const storeId = tool.data.get("STORE_ID")
      return await http.get(`${this.url}/verify/getStoreVerifyCodeList`, { storeId, ...params })
    }
  },
  store: {
    url: `${config.API_URL}`,
    name: "获取附近店铺点",
    get: async function (params) {
      return await http.get(`${this.url}/store/findNearbystores`, { radius: 10000, ...params })
    }
  },
  statistics: {
    url: `${config.API_URL}`,
    name: "获取店铺统计数据",
    get: async function (params) {
      const storeId = tool.data.get("STORE_ID")
      return await http.get(`${this.url}/store/statistics/getAllStoreStatistics`, { storeId, ...params })
    },
    getAllData: async function (data) {
      return await http.post(`${this.url}/store/manage/getAllStatistic`, { ...data })
    }
  },
  setting: {
    url: `${config.API_URL}`,
    name: "店铺设置",
    setStoreSetting: async function (params) {
      const storeId = tool.data.get("STORE_ID")
      return await http.get(`${this.url}/store/setting/set`, { storeId, ...params }) //调整店铺
    }
  }
}
